<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group label="Category">
      <b-form-checkbox
        v-for="option in categoryOptions"
        :key="option.stringID"
        v-model="categoryValue"
        :value="option._id"
        name="flavour-3a"
      >
        {{ option.name }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group
      label="Created At"
    >
      <b-input-group>
        <flat-pickr
          v-model="createdAtFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Lot Based?">
      <b-form-radio-group
        v-model="lotBasedFilterValue"
        :options="lotBasedOptions"
        name="customerBookable-radios-stacked"
        stacked
      />
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BInputGroup, BButton, BRow, BCol, BInputGroupAppend, BFormCheckbox, BFormRadioGroup,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BInputGroupAppend,
    BFormCheckbox,
    BFormRadioGroup,
    flatPickr,
  },
  props: {
    category: {
      type: [Array, null],
      default: null,
    },
    categoryOptions: {
      type: Array,
      required: true,
    },
    lotBasedFilter: {
      type: [String, null],
      default: null,
    },
    lotBasedOptions: {
      type: Array,
      required: true,
    },
    createdAtFilter: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      createdAtFilterValue: this.createdAtFilter,
      lotBasedFilterValue: this.lotBasedFilter,
      categoryValue: JSON.parse(JSON.stringify(this.category)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    category: {
      immediate: true,
      handler(val) {
        this.categoryValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    createdAtFilter: {
      immediate: true,
      handler(val) {
        this.createdAtFilterValue = val
      },
    },
    lotBasedFilter: {
      immediate: true,
      handler(val) {
        this.lotBasedFilterValue = val
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.createdAtFilterValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:category', this.categoryValue)
      this.$emit('update:createdAt', this.createdAtFilterValue)
      this.$emit('update:lotBasedFilter', this.lotBasedFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.createdAtFilterValue = ''
      this.lotBasedFilterValue = ''
      this.categoryValue = []

      this.$emit('update:category', this.categoryValue)
      this.$emit('update:createdAt', this.createdAtFilterValue)
      this.$emit('update:lotBasedFilter', this.lotBasedFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
